import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import Loading from "../components/layout/Loading";

const PrivateRoute = ({
  component: Component,
  userType,
  allowed = [],
  ...rest
}) => {
  const { isAuthenticated, authLoading, profile } = useSelector(
    (state) => state.auth
  );
  const role = profile?.config?.role ?? profile?.role;
  const normalizedRole = typeof role === "string" ? role.toLowerCase() : role;
  const normalizedAllowed = Array.isArray(allowed)
    ? allowed.map((item) =>
        typeof item === "string" ? item.toLowerCase() : item
      )
    : [];
  const token =
    typeof window !== "undefined" ? window.localStorage.getItem("token") : null;
  const waitingForRole =
    normalizedAllowed.length > 0 && isAuthenticated && !normalizedRole;
  const shouldDefer =
    authLoading || (token && !isAuthenticated) || waitingForRole;

  return (
    <Route
      {...rest}
      render={(props) =>
        shouldDefer ? (
          <Loading fullHeight />
        ) : !isAuthenticated ? (
          <Redirect
            to={{
              pathname: "/login",
              state: { message: "Please login to access that page" },
            }}
          />
        ) : normalizedAllowed.length > 0 &&
          normalizedRole &&
          !normalizedAllowed.includes(normalizedRole) ? (
          <Redirect
            to={{
              pathname: "/profile",
              state: {
                message: "You do not have permission to access that page",
              },
            }}
          />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

PrivateRoute.propTypes = {
  isAuthenticated: PropTypes.bool,
  loading: PropTypes.bool,
  allowed: PropTypes.array,
};

export default PrivateRoute;
